export enum ThemeVariableType {
  PrimaryColor = 'primary-color',
  PrimaryHoverColor = 'primary-hover-color',
  OnPrimaryColor = 'on-primary-color',
  OnPrimaryHoverColor = 'on-primary-hover-color',
  PrimaryContainerColor = 'primary-container-color',
  PrimaryContainerHoverColor = 'primary-container-hover-color',
  OnPrimaryContainerColor = 'on-primary-container-color',

  SecondaryColor = 'secondary-color',
  OnSecondaryColor = 'on-secondary-color',
  SecondaryContainerColor = 'secondary-container-color',
  OnSecondaryContainerColor = 'on-secondary-container-color',

  TertiaryColor = 'tertiary-color',
  OnTertiaryColor = 'on-tertiary-color',
  TertiaryContainerColor = 'tertiary-container-color',
  OnTertiaryContainerColor = 'on-tertiary-container-color',

  ErrorColor = 'error-color',
  OnErrorColor = 'on-error-color',
  ErrorContainerColor = 'error-container-color',
  OnErrorContainerColor = 'on-error-container-color',

  SurfaceDimColor = 'surface-dim-color',
  SurfaceColor = 'surface-color',
  SurfaceBrightColor = 'surface-bright-color',

  ContainerHighestColor = 'container-highest',
  ContainerHighColor = 'container-high',
  ContainerColor = 'container',
  ContainerLowColor = 'container-low',
  ContainerLowestColor = 'container-lowest',

  ContentBrightColor = 'content-bright',
  ContentLightColor = 'content-light',
  ContentNormalColor = 'content-normal',
  ContentDimColor = 'content-dim',
  ContentDarkColor = 'content-dark',
  ContentDarkestColor = 'content-darkest',

  UseScrollbarGradients = 'use-scrollbar-gradients',
  UseModernAuthLayout = 'use-modern-auth-layout',
  PreferBorders = 'prefer-borders',
  UseUnifiedMarkdownEditorBackground = 'use-unified-markdown-editor-background',
  ShouldUseLineStyleInFilters = 'should-use-line-style-in-filters',
  ShowNewMessageButtonOutsideInput = 'show-new-message-button-outside-input',
  ShowSidebarWorkspaceDropdownToggle = 'show-sidebar-workspace-dropdown-toggle',
  ShowSidebarFavouriteIconChips = 'show-sidebar-favourite-icon-chips',
  ShowCloudItemDetails = 'show-cloud-item-details',
  ShowCloudItemIcon = 'show-cloud-item-icon',
  ShowEmptyFilesPlaceholderVisual = 'show-empty-files-placeholder-visual',
  ShowEmptyConversationPlaceholderVisual = 'show-empty-conversation-placeholder-visual',
  ShowWorkspaceInviteAsButton = 'show-workspace-invite-as-button',
  ShouldShowModalHeaderBackgrounds = 'should-show-modal-header-backgrounds',
  ShouldShowBreadcrumbsTitleFirst = 'should-show-breadcrumbs-title-first',

  PaletteColors = 'palette-colors',
  PaletteColorMatrix = 'palette-color-matrix',

  BorderRadius = 'border-radius',
  Shadow = 'shadow',
  UsePaletteColorsInAvatars = 'use-palette-colors-in-avatars',
  MobileFontSizeFactor = 'mobile-font-size-factor',
  DatabaseTableHeaderDefaultBackgroundColor = 'database-table-header-default-background-color',
  DatabaseTableHeaderHoverBackgroundColor = 'database-table-header-hover-background-color',
  DatabaseCellHoverBackgroundColor = 'database-cell-hover-background-color',
  DatabaseCellHoverBorder = 'database-cell-hover-border',
  DatabaseCellFocusHoverBorder = 'database-cell-focus-hover-border',
  DatabaseRelationIconBackgroundColor = 'database-relation-icon-background-color',
  DatabaseRelationIconBackgroundHoverColor = 'database-relation-icon-background-hover-color',
  DatabaseTableColumnNameAlignment = 'database-table-column-name-alignment',
  FileIconWeightType = 'file-icon-weight-type',
  ShouldClampNotificationTitleItem = 'should-clamp-notification-title-item',
  NotificationIconWeightType = 'notification-icon-weight-type',
  ShowNotificationResourceSpace = 'show-notification-resource-space',
  PreferredIconWeightType = 'preferred-icon-weight-type',
  DatabaseHeaderGroupDropdownPlacement = 'database-header-group-dropdown-placement',
  DashboardRecentListBackgroundColor = 'dashboard-recent-list-background-color',
  DashboardRecentListHorizontalPadding = 'dashboard-recent-list-horizontal-padding',
  ShowDashboardRecentItemBorders = 'show-dashboard-recent-item-borders',
  UseStickyDashboardResourcesButton = 'use-sticky-dashboard-resources-button',
  ShouldShowDashboardAndKanbanInContainer = 'should-show-dashboard-and-kanban-in-container',
  UseDetachedDashboardWidgetTypePreview = 'use-detached-dashboard-widget-type-preview',
  CanCreateConversationDashboardWidget = 'can-create-conversation-dashboard-widget',
  UseCenteredTimeTrackerCellLayout = 'use-centered-time-tracker-cell-layout',
  TimeTrackerDropdownLayoutType = 'time-tracker-dropdown-layout-type',
  ChoosePropertyTypeLayoutType = 'choose-property-type-layout-type',
  StatusDropdownLayoutType = 'status-dropdown-layout-type',
  ItemGroupHeaderLayoutType = 'item-group-header-layout-type',
}
